export default __webpack_public_path__ + "images/fp-circle-success.svg";